(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[137],{

/***/ 32292:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[category]/[...slug]",
      function () {
        return __webpack_require__(49967);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 31233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Image; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./src/components/Image/Picture.js


var defaultProps = {};
var propTypes = {
    children: (prop_types_default()).node.isRequired
};
function Picture(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("picture", {
        children: children
    });
};
Picture.defaultProps = defaultProps;
Picture.propTypes = propTypes;

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
;// CONCATENATED MODULE: ./src/components/Image/Img.js



/* eslint-disable @next/next/no-img-element */ 


var Img_defaultProps = {
    fluid: true,
    title: null,
    className: null
};
var Img_propTypes = {
    src: (prop_types_default()).string.isRequired,
    alt: (prop_types_default()).string.isRequired,
    fluid: (prop_types_default()).bool,
    title: (prop_types_default()).string,
    className: (prop_types_default()).string
};
function Img(_param) {
    var src = _param.src, alt = _param.alt, fluid = _param.fluid, title = _param.title, className = _param.className, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "alt",
        "fluid",
        "title",
        "className"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", (0,_object_spread/* default */.Z)({
        src: src,
        alt: alt,
        title: title,
        className: (0,clsx_m/* default */.Z)(fluid && "h-auto max-w-full", className),
        loading: "lazy"
    }, rest));
}
Img.defaultProps = Img_defaultProps;
Img.propTypes = Img_propTypes;
var ImgForwardRef = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Img, (0,_object_spread/* default */.Z)({
        ref: ref
    }, props));
});
ImgForwardRef.displayName = "ImgForwardRef";
/* harmony default export */ var Image_Img = (ImgForwardRef);

;// CONCATENATED MODULE: ./src/components/Image/isRemote.js
function isRemote(src) {
    return src.indexOf("//") !== -1;
};

;// CONCATENATED MODULE: ./src/components/Image/localImageSource.js
function localImageSource(src) {
    return "/images/".concat(src);
};

;// CONCATENATED MODULE: ./src/components/Image/Source.js


var Source_defaultProps = {
    sizes: null,
    srcset: null,
    media: "all"
};
var Source_propTypes = {
    sizes: (prop_types_default()).string,
    srcset: (prop_types_default()).string,
    type: (prop_types_default()).string.isRequired,
    media: prop_types_default().oneOfType([
        prop_types_default().oneOf([
            "all",
            "print",
            "screen",
            "speech"
        ]),
        (prop_types_default()).string, 
    ])
};
function Source(param) {
    var sizes = param.sizes, srcset = param.srcset, type = param.type, media = param.media;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
        sizes: sizes,
        srcSet: srcset,
        type: type,
        media: media
    });
};
Source.defaultProps = Source_defaultProps;
Source.propTypes = Source_propTypes;

;// CONCATENATED MODULE: ./src/components/Image/renderSources.js


function renderSources(sources) {
    var keys = Object.keys(sources);
    if (keys === null || keys.length === 0) {
        return null;
    }
    return keys.map(function(type, index) {
        var src = sources[type];
        var srcSet = src;
        var sizes = null;
        if (Array.isArray(src) === true) {
            srcSet = src[0];
            sizes = src[1];
        }
        return renderSource(index, type, srcSet, sizes);
    });
};
function renderSource(index, type, srcSet) {
    var sizes = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Source, {
        type: type,
        srcSet: srcSet,
        sizes: sizes
    }, "source-".concat(index));
}

;// CONCATENATED MODULE: ./src/components/Image/Image.js










var Image_defaultProps = {
    fluid: false,
    sources: null,
    srcSet: null,
    sizes: null,
    className: ""
};
var Image_propTypes = {
    src: (prop_types_default()).string.isRequired,
    sources: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).object
    ]),
    srcSet: (prop_types_default()).string,
    sizes: (prop_types_default()).string,
    fluid: (prop_types_default()).bool,
    className: (prop_types_default()).string
};
function Image(_param) {
    var src = _param.src, sources = _param.sources, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "sources"
    ]);
    var hasSources = sources && sources.length !== 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Picture, {
        children: [
            hasSources && renderSources(sources),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_Img, (0,_object_spread/* default */.Z)({
                src: isRemote(src) ? src : localImageSource(src)
            }, rest))
        ]
    });
}
Image.defaultProps = Image_defaultProps;
Image.propTypes = Image_propTypes;
var ImageForwardRef = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) /*#__PURE__*/ {
    var alt = _param.alt, props = (0,_object_without_properties/* default */.Z)(_param, [
        "alt"
    ]);
    return (0,jsx_runtime.jsx)(Image, (0,_object_spread/* default */.Z)({
        ref: ref,
        alt: alt
    }, props));
});
ImageForwardRef.displayName = "ImageForwardRef";
/* harmony default export */ var Image_Image = (ImageForwardRef);

;// CONCATENATED MODULE: ./src/components/Image/index.js

/* harmony default export */ var components_Image = (Image_Image);


/***/ }),

/***/ 96829:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Categories; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var _components_Container__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30341);
/* harmony import */ var _components_Link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48300);





var defaultProps = {
    categories: [],
    active: null
};
var propTypes = {
    categories: prop_types__WEBPACK_IMPORTED_MODULE_3___default().arrayOf((prop_types__WEBPACK_IMPORTED_MODULE_3___default().object)),
    active: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string)
};
function Categories(param) {
    var categories = param.categories, active = param.active;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "relative z-20 bg-gray-900 text-gray-100",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Container__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                className: "flex w-full items-center space-x-4 py-2 lg:py-3",
                children: categories.map(function(param) {
                    var id = param.id, slug = param.slug, name = param.name, uri = param.uri;
                    var isActive = active === slug;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Link__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        href: uri,
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("flex items-center font-medium transition duration-150 ease-in-out md:text-lg", isActive === true && "pointer-events-none text-green-500", isActive === false && "border-transparent text-gray-300 hover:text-white"),
                        children: name
                    }, id);
                })
            })
        })
    });
};
Categories.defaultProps = defaultProps;
Categories.propTypes = propTypes;


/***/ }),

/***/ 10508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ formatDate; }
/* harmony export */ });
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);

function formatDate(d) {
    var format = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "short";
    var f;
    switch(format){
        case "short":
            f = "MMMM DD, YYYY";
            break;
        default:
            f = "MMMM/DD/YYYY";
            break;
    }
    return moment__WEBPACK_IMPORTED_MODULE_0___default()(d).format(f);
};


/***/ }),

/***/ 49967:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Post; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/components/Container/index.js
var Container = __webpack_require__(30341);
// EXTERNAL MODULE: ./src/domain/Blog/Categories.js
var Categories = __webpack_require__(96829);
// EXTERNAL MODULE: ./src/components/Link/index.js + 2 modules
var Link = __webpack_require__(48300);
;// CONCATENATED MODULE: ./src/domain/Post/PostBreadcrumb.js


function PostBreadcrumb(param) {
    var categories = param.categories;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "text-lg lg:text-xl",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                href: "/blog",
                className: "font-semibold text-green-500 hover:text-green-600 inline-flex items-center -ml-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        className: "h-6 w-6",
                        viewBox: "0 0 20 20",
                        fill: "currentColor",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fillRule: "evenodd",
                            d: "M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z",
                            clipRule: "evenodd"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "Blog"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center space-x-2 -ml-2 mt-1 md:mt-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-gray-300 font-bold",
                        children: "/"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-base lg:text-lg font-semibold text-gray-900",
                        children: categories.map(function(param) {
                            var slug = param.slug, name = param.name, uri = param.uri;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                href: uri,
                                children: name
                            }, slug);
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/Image/index.js + 7 modules
var Image = __webpack_require__(31233);
;// CONCATENATED MODULE: ./src/domain/Blog/PostAuthor.js



function PostAuthor(param) {
    var _trainer = param.trainer, title = _trainer.title, featuredImage = _trainer.featuredImage, uri = _trainer.uri, position = param.position;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
        href: uri,
        className: "flex items-center space-x-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "h-12 w-12",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    alt: title,
                    src: featuredImage.node.sourceUrl,
                    className: "block h-12 w-12 rounded-full"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col space-y-2 lg:space-y-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        className: "m-0 text-base font-semibold leading-none lg:text-lg",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-sm leading-none text-gray-500 lg:text-base",
                        children: position
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/domain/Post/PostTrainer.js


function PostTrainer(param) {
    var trainer = param.trainer;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "pt-5",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PostAuthor, {
            trainer: trainer,
            position: "Entrenador"
        })
    });
};

;// CONCATENATED MODULE: ./src/domain/Post/PostTitle.js

function PostTitle(param) {
    var title = param.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
        className: "text-4xl lg:text-5xl tracking-tight font-bold leading-10 lg:w-5/6",
        children: title
    });
};

// EXTERNAL MODULE: ./src/helpers/formatDate.js
var formatDate = __webpack_require__(10508);
;// CONCATENATED MODULE: ./src/domain/Post/PostDate.js


function PostDate(param) {
    var date = param.date;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "text-gray-500 border-l border-green-500 pl-4 leading-tight lg:text-lg",
        children: (0,formatDate/* default */.Z)(date, "short")
    });
};

;// CONCATENATED MODULE: ./src/domain/Post/PostFeaturedImage.js


function PostFeaturedImage(param) {
    var title = param.title, image = param.image;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "rounded overflow-hidden",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
            src: image.sourceUrl,
            alt: title
        })
    });
};

;// CONCATENATED MODULE: ./src/domain/Post/PostContent.js

function PostContent(param) {
    var content = param.content;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "prose lg:prose-lg font-normal overflow-x-hidden",
        dangerouslySetInnerHTML: {
            __html: content
        }
    });
};

;// CONCATENATED MODULE: ./src/domain/Post/PostDisclaimer.js


function PostDisclaimer() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col lg:flex-row lg:items-start lg:space-x-4 bg-white rounded-lg shadow p-4 lg:p-6",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    className: "w-6 h-6 text-yellow-400",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 20 20",
                    fill: "currentColor",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        d: "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z",
                        clipRule: "evenodd"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-sm lg:text-xs text-gray-500",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "leading-relaxed",
                    children: "Este blog proporciona informaci\xf3n general y discusi\xf3n sobre el marco de trabajo Scrum, Agile y temas relacionados."
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/pages/blog/[category]/[...slug].js











var defaultProps = {
    categories: []
};
var propTypes = {
    post: (prop_types_default()).object.isRequired,
    categories: prop_types_default().arrayOf((prop_types_default()).object)
};
var __N_SSG = true;
function Post(param) {
    var post = param.post, categories = param.categories;
    var ref, ref1, ref2;
    var trainer = (ref = post.info) === null || ref === void 0 ? void 0 : ref.trainer;
    var featuredImage = (ref1 = post.featuredImage) === null || ref1 === void 0 ? void 0 : ref1.node;
    var hasTrainer = trainer !== null;
    var hasFeaturedImage = featuredImage !== null;
    var hasCategories = (post === null || post === void 0 ? void 0 : (ref2 = post.categories) === null || ref2 === void 0 ? void 0 : ref2.nodes) !== null;
    var hasGlobalCategories = categories.length !== 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            hasGlobalCategories && /*#__PURE__*/ (0,jsx_runtime.jsx)(Categories/* default */.Z, {
                categories: categories
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-gray-100 py-10 lg:py-20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.ZP, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid grid-cols-1 space-y-10 lg:grid-cols-12 lg:gap-10 lg:space-y-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "lg:col-span-3 lg:pt-4 lg:pb-20",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "lg:sticky lg:top-32 lg:space-y-20",
                                    children: [
                                        hasCategories && /*#__PURE__*/ (0,jsx_runtime.jsx)(PostBreadcrumb, {
                                            categories: post.categories.nodes
                                        }),
                                        hasTrainer && /*#__PURE__*/ (0,jsx_runtime.jsx)(PostTrainer, {
                                            trainer: trainer
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "space-y-10 lg:col-span-9 lg:pr-20",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "space-y-10",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PostTitle, {
                                                title: post.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PostDate, {
                                                date: post.date
                                            }),
                                            hasFeaturedImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(PostFeaturedImage, {
                                                title: post.title,
                                                image: featuredImage
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PostContent, {
                                        content: post.content
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PostDisclaimer, {})
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
Post.defaultProps = defaultProps;
Post.propTypes = propTypes;


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(32292); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);